import { render, staticRenderFns } from "./coding.vue?vue&type=template&id=d843b498&scoped=true&"
import script from "./coding.vue?vue&type=script&lang=ts&"
export * from "./coding.vue?vue&type=script&lang=ts&"
import style0 from "./coding.vue?vue&type=style&index=0&id=d843b498&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d843b498",
  null
  
)

export default component.exports